import { Accordion as Accordion$1, accordionClasses, AccordionDetails as AccordionDetails$1, AccordionSummary as AccordionSummary$1, accordionSummaryClasses, Button, Menu, paperClasses, menuItemClasses, avatarClasses, Divider, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import Arrow from "./assets/icons/Arrow.js";
import Employees from "./assets/icons/Employees.js";
import "react/jsx-runtime";
const Accordion = styled(Accordion$1)`
  max-height: auto;

  &.${accordionClasses.expanded} {
    margin-top: 0;
  }
`;
const AccordionDetails = styled(AccordionDetails$1)`
  padding: 0;
`;
const AccordionSummary = styled(AccordionSummary$1)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  height: "48px",
  [`& .${accordionSummaryClasses.content}`]: {
    alignItems: "center"
  },
  [`&.${accordionSummaryClasses.expanded}`]: {
    minHeight: "auto"
  }
}));
const DropdownButton = styled(Button, {
  shouldForwardProp: (props) => props !== "isOpen"
})(
  ({ theme, isOpen, fullWidth }) => `
    flex-shrink: 0;
    width: auto;
 
    @media print {
      display: none;
    }
 
    background-color: ${isOpen ? theme.palette.primary[50] : "#ffffff"};
    width: ${fullWidth ? "100%" : "initial"};
  `
);
const DropdownText = styled(Button)(
  ({ theme }) => `
    && {
      color: ${theme.palette.common.black};
    }
  `
);
const practitionersIcon = styled(Employees)(() => ``);
const ArrowIcon = styled(Arrow, {
  shouldForwardProp: (props) => props !== "isOpen"
})(
  ({ isOpen }) => `
    transform: ${isOpen ? "rotate(180deg)" : "none"};
  `
);
const SearchMenu = styled(Menu, {
  shouldForwardProp: (props) => props !== "width" && props !== "maxHeight"
})(
  ({ width, maxHeight }) => `
    & > .${paperClasses.root} {
      ${maxHeight ? `max-height: ${maxHeight}px;` : ""}
      width: ${width}px;
      overflow: scroll;
    }

    & .${paperClasses.root} {
      margin: 0;
    }

    & .${paperClasses.root}:before {
      display: none;
    }

    & .${paperClasses.root}:nth-child(2) {
      box-shadow: none;
      border-top: 1px solid #E0E0E0;
    }

    & .${paperClasses.root}:nth-child(1) {
      box-shadow: none;
    }

    & .${menuItemClasses.root} {
      & .${avatarClasses.root} + span {
        max-width: 102px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  `
);
const SearchDivider = styled(Divider)(({ theme }) => ({
  margin: 0,
  backgroundColor: theme.palette.grey[300]
}));
const RoleCount = styled(Typography)({
  marginLeft: "8px",
  display: "inline"
});
const StatusTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[800],
  marginRight: "8px"
}));
const StatusCount = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary[900],
  backgroundColor: theme.palette.primary[75],
  borderRadius: "50%",
  width: "18px",
  height: "18px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}));
export {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  ArrowIcon,
  DropdownButton,
  DropdownText,
  RoleCount,
  SearchDivider,
  SearchMenu,
  StatusCount,
  StatusTitle,
  practitionersIcon
};
